<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl titulo="Reporte / Artículo"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
            <a id="catalogos" (click)="ctrl.cargarCatalogo('articulos', 'articulos?order=categorias_id');"></a>
            <app-simple-opciones [ctrl]="ctrl"></app-simple-opciones>
            
            <div id="imprimir"  style="overflow:auto;" [style.height.px]="ctrl.tamano-160">                    
                <!--Tabla -->
                <table id class="table is-striped is-fullwidth" *ngIf="!ctrl.cargando " >
                    <thead>
                        <tr>
                            <th>Clave</th>
                            <th>Código barras</th>
                            <th>Nombre</th>
                            <th>Categoría</th>
                            <th>Existencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.articulos; let i=index">
                            <th style="vertical-align: middle; font-size:13px; text-align:center;">{{ item.clave }}</th>
                            <td style="vertical-align: middle; font-size:13px; text-align:center;"><strong>{{item.codigo_barras}} </strong></td>
                            <td style="vertical-align: middle; font-size:11px; text-align:left;">{{ item.nombre }} </td>
                            <td style="vertical-align: middle; font-size:11px; text-align:left;">{{item.categorias.nombre }}</td>
                            <td style="vertical-align: middle; font-size:13px; text-align:center;">{{ item.existencia }}</td>
                        </tr>
                        <tr *ngIf="ctrl.articulos.length == 0">
                            <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</div>